/** ABP permission names для модуля депонирования (как в Swagger / backend-ui). */

const POLICY = {
  /** Как в backend-ui (`DEPOSITS_MODERATE_PERMISSION`). */
  moderate: "LeninkaArt.Deposits.Moderate",
  /** Старое/альтернативное имя в некоторых конфигурациях. */
  approve: "LeninkaArt.Deposits.Approve",
  create: "LeninkaArt.Deposits.Create",
  edit: "LeninkaArt.Deposits.Edit",
} as const

/**
 * Сузовая модерация по `DepositIndustryDirection` (0–6), см. бэкенд-политику
 * `LeninkaArt.Deposits.Moderate.Industry.*`.
 */
export const DEPOSIT_INDUSTRY_MODERATION_PERMISSIONS = [
  "LeninkaArt.Deposits.Moderate.Industry.TextAndMeaningIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.VisualImageIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.AudioAndSoundIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.PerformingArtsIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.DigitalInteractiveIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.ScienceAndEducationIndustries",
  "LeninkaArt.Deposits.Moderate.Industry.CraftAndAppliedArtsIndustries",
] as const

const isGranted = (policies: Record<string, boolean> | null, key: string) => Boolean(policies?.[key])

const hasAnyIndustryModeration = (grantedPolicies: Record<string, boolean> | null) =>
  DEPOSIT_INDUSTRY_MODERATION_PERMISSIONS.some((name) => isGranted(grantedPolicies, name))

/**
 * Вкладка «Модерация депонирования»: глобальный Moderate, legacy Approve
 * или хотя бы одно отраслевое право `Moderate.Industry.*`.
 */
export const canSeeDepositModerationNav = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, POLICY.moderate) ||
  isGranted(grantedPolicies, POLICY.approve) ||
  hasAnyIndustryModeration(grantedPolicies)

/** Новая заявка / редактирование черновика (если на бэкенде включены политики). */
export const canCreateOrEditDeposit = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, POLICY.create) || isGranted(grantedPolicies, POLICY.edit)
